import Axios from 'axios';

// The plato_api error shape: `{ errors: [...] }` on a 422; anything else falls back.
const apiErrorMessage = (error: unknown, fallback: string) => {
  const errors = Axios.isAxiosError(error) ? error.response?.data?.errors : undefined;
  return Array.isArray(errors) && errors.length > 0 ? errors.join(' ') : fallback;
};

export default apiErrorMessage;
